import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import Sidebar from './Sidebar'




class TechConseil extends Component {
  render() {
    return (
    <div>   
    <section className="inner-intro bg-image  parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/branding/pmg5.jpg")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Nos services</a>/<span>Technicien Conseil</span>
                    </div>
                </div>
            </div>
        </section>
    <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
                <div className="row text-center inside_content">
                
                    <div className="col-md-8">
                <h3 className="search_inno"><img src="/assets/img/leaf.png" className="leaf-sidebar"/>  Technicien conseil </h3> 
                <div className="content">                       
                    <p>Accompagner quotidiennement les agriculteurs dans leur approche de la fertilisation biologique et s’engager dans la voie d’avenir du développement durable.</p>
                    <p>Au-delà du conseil technique, c’est une approche et une analyse globale de l’exploitation qui sont proposées aux agriculteurs.</p>
                    <p>Un conseil sur mesure pour répondre à chaque situation, du conseil jusqu’aux résultats techniques et économiques :</p>
                      
                                <div className="accordion">
                            <div className="accordion-section">
                                <h6 className="accordion-title  accor_title_tech">Compréhension</h6>
                                <div className="accordion-content active defualt-hidden">
                                    <p>Compréhension de la problématique de l’agriculteur dans son environnement.</p>
                                </div>
                            </div>
                            <div className="accordion-section">
                                <h6 className="accordion-title accor_title_tech">Conseil</h6>
                                <div className="accordion-content">
                                    <p>Conseil d’une solution sur-mesure, efficace et pérenne.</p>
                                   
                                </div>
                            </div>
                            <div className="accordion-section">
                                <h6 className="accordion-title accor_title_tech">Suivi</h6>
                                <div className="accordion-content">
                                   <p>Suivi de la mise en place et réponse à toutes les questions</p>

                                </div>
                            </div>
                            <div className="accordion-section">
                                <h6 className="accordion-title accor_title_tech">Analyse</h6>
                                <div className="accordion-content">
                                    <p>Analyse de la performance de la situation.</p>
                                </div>
                            </div>
                        </div>


                    <a href="/contact-tech">
                    <button className="btn btn-md btn-black form-full" type="submit" id="form-submit" name="submit">Demander un technicien conseil</button>
                    </a>
          
                </div>
                </div>
            <Sidebar/>
                
            </div>
             </div>
        </section>

<hr />

    </div>
       
        

    )
  }
}
export default TechConseil;


// WEBPACK FOOTER //
// ./src/components/tech-conseil.jsx